import axios from 'axios';

const prefix = '/fulfillmentProvidersGrid';

export const getFulfillmentProvidersGridData = (getFulfillmentProvidersGridDataRequest) => {
  return axios.post(prefix, getFulfillmentProvidersGridDataRequest);
};
